import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Power = createReactComponent("Power", ["svg", defaultAttributes, [["path", {
  d: "M18.36 6.64a9 9 0 11-12.73 0",
  key: "2o6fg1"
}], ["line", {
  x1: "12",
  y1: "2",
  x2: "12",
  y2: "12",
  key: "14lt8r"
}]]]);
export default Power;